(function(){
	'use strict';

	angular
		.module('app.products')
		.component('personalizeProcessoPintura', personalizeProcessoPinturaComponent());

	function personalizeProcessoPinturaComponent() {
		return {
			template: '',
			bindings: {},
			controller: PersonalizeProcessoPinturaController,
			controllerAs: 'vm',
			transclude: false,
			templateUrl: 'products/components/personalize-processo-pintura.template.html'
		}
	}

	function PersonalizeProcessoPinturaController(API) {
		let vm = this;

		vm.textPrePintura = [];
		vm.textPosPintura = [];

		vm.$onInit = () => {
			_loadFromApi();
		}

		function _loadFromApi() {
			_loadPage();
			_loadPrePintura();
			_loadPosPintura();
		}

		function _loadPage(){
			API.get('paginas/2')
				.then(result => vm.page = result.data[0])
				.catch(error => {
					console.log(error);
				});
		}

		function _loadPrePintura() {
			API.get(`paginas/4`)
				.then(result => vm.textPrePintura = result.data[0])
				.catch(error => {
					console.log(error);
				});
		}

		function _loadPosPintura() {
			API.get(`paginas/5`)
				.then(result => vm.textPosPintura = result.data[0])
				.catch(error => {
					console.log(error);
				});
		}
	}

})();
